/**
 * Artwork gallery lightbox: opens the full, uncropped artwork in a native <dialog>.
 * Esc closes (native), Left/Right arrows move between pieces, focus returns to the opener.
 */
if (!customElements.get('itc-gallery')) {
  customElements.define(
    'itc-gallery',
    class ItcGallery extends HTMLElement {
      connectedCallback() {
        this.openers = Array.from(this.querySelectorAll('.itc-gallery__open'));
        this.dialog = this.querySelector('.itc-lightbox');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.img = this.dialog.querySelector('.itc-lightbox__img');
        this.caption = this.dialog.querySelector('.itc-lightbox__caption');
        this.index = 0;

        this.openers.forEach((button, index) => button.addEventListener('click', () => this.open(index)));
        this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.querySelector('[data-prev]').addEventListener('click', () => this.step(-1));
        this.dialog.querySelector('[data-next]').addEventListener('click', () => this.step(1));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.step(1);
          if (event.key === 'ArrowLeft') this.step(-1);
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.removeProperty('overflow');
          this.openers[this.index]?.focus();
        });

        const single = this.openers.length < 2;
        this.dialog.querySelector('[data-prev]').hidden = single;
        this.dialog.querySelector('[data-next]').hidden = single;
      }

      show(index) {
        const button = this.openers[index];
        this.index = index;
        this.img.src = button.dataset.full;
        this.img.alt = button.dataset.alt || '';
        this.caption.textContent = button.dataset.caption || '';
        this.caption.hidden = !button.dataset.caption;
      }

      open(index) {
        this.show(index);
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }

      step(delta) {
        const count = this.openers.length;
        this.show((this.index + delta + count) % count);
      }
    }
  );
}
